import React, { useEffect } from 'react';
import { Button } from '@asigna/kit';
import { NoData } from 'components';
import { SendStxsDialog } from 'components/Dialog/TransactionDialog/SendStxsDialog';
import { SkeletonStx20 } from 'components/Skeletons/SkeletonAsset';
import {
  TransactionNotification,
  TransactionResultStatus,
} from 'components/TransactionNotification/TransactionNotification';
import useNetwork from 'hooks/use-network';
import { uniqueId } from 'lodash';
import WorldIcon from 'modules/icons/icon-world.svg';

import { getDomainsByAddress } from '../../../utils';
import { Pagination } from '../../Pagination';

import { useStxsTab } from './util/useStxsTab';
import { useStxsStyles } from './StxsStyles';

type Props = {
  currentSafe: string;
};

export const StxsTab = ({ currentSafe }: Props) => {
  const classes = useStxsStyles();
  const LIMIT = 8;
  const [network] = useNetwork();
  const {
    isLoading,
    setLoading,
    searchDomainResult,
    setSearchDomainResult,
    currentPage,
    setCurrentPage,
    pagination,
    setPagination,
    transferredAsset,
    setTransferredAsset,
    instantSendDialogShown,
    setInstantSendDialogShown,
    transactionMessagePopupShown,
    setTransactionMessagePopupShown,
    transactionResultStatus,
    setTransactionResultStatus,
    transactionResultMessage,
    setTransactionResultMessage,
  } = useStxsTab();

  const fetchDomain = async (address: string) => {
    setLoading(true);
    setSearchDomainResult(undefined);
    try {
      const result = await getDomainsByAddress(address, currentPage, LIMIT, network);
      setSearchDomainResult(result.data);
      setPagination(result.pagination);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDomain(currentSafe);
  }, [currentSafe, currentPage]);

  return (
    <div className={classes.stxsWrapper}>
      {searchDomainResult && searchDomainResult?.length > 0 && (
        <div className={classes.stxsHeader}>
          <span>Domain name</span>
          {/* <span>Registered at</span>
          <span>Owner</span> */}
          <span></span>
        </div>
      )}
      {isLoading ? (
        <SkeletonStx20 />
      ) : (
        <div className={classes.contentWrapper}>
          {searchDomainResult && searchDomainResult?.length > 0 ? (
            searchDomainResult?.map((domain) => (
              <div className={classes.tableRow} key={uniqueId(domain.domain)}>
                <div className={classes.domainName}>
                  <div className={classes.rowTableIcon}>
                    <img src={WorldIcon} alt="" />
                  </div>
                  <div className={classes.caption}>
                    {domain.domain.split('.')[0]}
                    <span>.{domain.domain.split('.')[1]}</span>
                  </div>
                </div>
                {/* <div className={classes.itemRow}>
                  <div className={classes.title}>{formatSafeDate(domain.creationDate)}</div>
                </div> */}
                {/* <div className={classes.ownerRow}>
                  <div className={classes.title}>{shortenAddress(domain.owner)}</div>
                  <CopyAddress address={domain.owner} />
                  <div
                    className={classes.sendBlock}
                    onClick={() => window.open(getAccountExplorerUrl(domain.owner, network))}
                  >
                    <img src={LinkIcon} alt="" />
                  </div>
                </div> */}
                <div className={classes.itemActions}>
                  <Button
                    colorType="secondary"
                    onClick={(e) => {
                      e.stopPropagation();
                      setTransferredAsset(domain.domain);
                      setInstantSendDialogShown(true);
                    }}
                    message="Send"
                  />
                </div>
              </div>
            ))
          ) : (
            <div className={classes.noDataWrapper}>
              <NoData isAssets style={{ margin: '32px 0 16px' }} />
              <Button
                onClick={() => window.open('https://stx20.com/marketplace', `_blank`)}
                message="Go to STX20 Marketplace"
                colorType="secondary"
                size="md"
              />
            </div>
          )}
          <Pagination
            currentPage={pagination?.page || 0}
            pageCount={Math.ceil(Number(pagination?.count || 1) / LIMIT)}
            onChange={(val) => {
              setCurrentPage(val);
            }}
          />
        </div>
      )}
      {instantSendDialogShown && (
        <SendStxsDialog
          open={instantSendDialogShown}
          transferredAsset={transferredAsset}
          safeAddress={currentSafe}
          onClose={() => setInstantSendDialogShown(false)}
          onContinue={(successful, message) => {
            setTransactionMessagePopupShown(true);
            setTransactionResultStatus(
              successful ? TransactionResultStatus.success : TransactionResultStatus.rejected
            );
            setTransactionResultMessage(message);
          }}
        />
      )}
      {transactionMessagePopupShown && (
        <TransactionNotification
          open={transactionMessagePopupShown}
          onClose={() => setTransactionMessagePopupShown(false)}
          resultStatus={transactionResultStatus}
          description={transactionResultMessage}
        />
      )}
    </div>
  );
};
